import { Component, computed, input } from '@angular/core'
import { RouterLink } from '@angular/router'
import { Uuid } from '@ftr/contracts/type/shared'
import { DateComponent, DateFormat, IconLegacyComponent } from '@ftr/foundation'
import { AppPaths, RequestPaths, RequestQueryParams } from '@ftr/routing-paths'
import { CartGroup } from '../../../store'
import { RequestTypeUrlValue } from '../../../types'

@Component({
  selector: 'ftr-request-cart-group-metadata',
  templateUrl: './request-cart-group-metadata.component.html',
  styleUrl: './request-cart-group-metadata.component.css',
  imports: [DateComponent, IconLegacyComponent, RouterLink],
})
export class RequestCartGroupMetadataComponent {
  readonly courtSystemId = input.required<Uuid>()
  readonly requestType = input.required<RequestTypeUrlValue>()
  readonly group = input.required<CartGroup>()
  readonly courthouseFullWidth = input<boolean>()

  protected readonly dateFormat = DateFormat.DateLong

  protected readonly courthousePath = computed<string[]>(() => [
    '/',
    AppPaths.Request,
    this.requestType(),
    RequestPaths.CourtSystem,
    this.courtSystemId(),
    RequestPaths.Courthouse,
    this.group().courthouse.id,
  ])
  protected readonly courtroomPath = computed<string[]>(() => [
    ...this.courthousePath(),
    RequestPaths.Courtroom,
    this.group().courtroom.id,
  ])

  protected readonly datePath = computed<string[]>(() => [...this.courtroomPath()])
  protected readonly dateQueryParam = computed(() => {
    return { [RequestQueryParams.CourtroomCalendarDate]: this.group().recordingDate.toString() }
  })
}
